var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("label",null,{"label":_vm.topLabel}),_vm._v(" "),(!_vm.tooltip)?_c('span',{staticClass:"cursor-pointer flex flex-wrap items-center"},[_vm._l((_vm.carriers),function(carrier){return _vm._t("default",null,{"carrier":carrier})}),_vm._v(" "),_vm._t("icon")],2):_vm._e(),_vm._v(" "),(_vm.tooltip)?_c('Popover',{attrs:{"modifiers":[
      {
        name: 'offset',
        options: {
          offset: [0, 8],
        },
      } ]},scopedSlots:_vm._u([{key:"trigger",fn:function(ref){
    var show = ref.show;
    var hide = ref.hide;
    var attrs = ref.attrs;
return [_c('span',_vm._b({staticClass:"cursor-pointer flex flex-wrap items-center",on:{"focusin":show,"focusout":hide,"mouseleave":hide,"mouseover":show}},'span',attrs,false),[_vm._l((_vm.carriers),function(carrier){return _vm._t("default",null,{"carrier":carrier})}),_vm._v(" "),_vm._t("icon")],2)]}},{key:"content",fn:function(ref){
    var position = ref.position;
return [_c('div',{staticClass:"max-w-[36rem]"},[_c('Tooltip',{attrs:{"position":position}},[_vm._v("\n          "+_vm._s(_vm.toolTipText)+"\n        ")])],1)]}}],null,true)}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }